import React from 'react';

export const Badge = ({ badgeCopy, isDiscountBadge = false }: { badgeCopy: string; isDiscountBadge?: boolean }) => {
  return (
    <div className={`product-card-badge ${isDiscountBadge ? 'discount-badge' : ''}`}>
      {isDiscountBadge ? `Save ${badgeCopy.replace(' Off', '')}` : badgeCopy}
    </div>
  );
};
